"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Context = require("../../Context");
var _menu = require("../../../utils/menu");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class Submenu extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.withinSameModule = link => !!((0, _menu.isWithinSameModule)(link, this.context.appPrefix) && this.props.history);
    this.handleNavigate = link => {
      const nextPath = (0, _menu.getPathFromLink)(link, this.context.appPrefix);
      this.props.history.push(nextPath);
    };
  }
  render() {
    return _react.default.createElement("div", {
      ref: this.props.innerRef
    }, this.props.sections.map((section, idx) => _react.default.createElement("div", {
      key: idx
    }, _react.default.createElement(_styles.SubmenuSection, {
      href: this.withinSameModule(section.uri) ? null : section.uri,
      onClick: this.withinSameModule(section.uri) ? () => this.handleNavigate(section.uri) : null,
      target: section.meta && section.meta.newTab ? '_blank' : '_self'
    }, _react.default.createElement(_styles.SubmenuSectionTitle, {
      lines: 3,
      text: section.label,
      title: section.label
    })), section.children && !!section.children.length && _react.default.createElement(_styles.SectionDivider, null), this.props.children(section.children, this.props.level + 1))));
  }
}
Submenu.defaultProps = {
  sections: [],
  innerRef: () => {}
};
Submenu.contextType = _Context.ConfigContext;
var _default = exports.default = Submenu;